import React from "react";
import Navbar from "../../components/navbar";
import Footer from "../../components/footer";

class ContactsPage extends React.Component {
    render() {
        return (
            <div>
                <div className="col-md-12">
                    <div className="row">
                        <div className="col-md-10">

                        </div>
                        <div className="col-md-2">

                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default ContactsPage;